import { getRequest } from 'utils/http'

export const getCompaniesApi = () => {
  return getRequest(`/company`)
}
